export default {
    getInterviewFilter: (state) => state.filter,
    getInterviewList: (state) => state.list,
    getInterviewResult: (state) => state.result,
  };
  